(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:infiniteScroll
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <infinite-scroll></infinite-scroll>
       </file>
     </example>
   *
   */
  angular
    .module('core')
    .directive('infiniteScroll', infiniteScroll);

  function infiniteScroll($rootScope, $window, $timeout, $log) {
    return {
      restrict: 'A',
      scope: {},
      replace: false,
      controllerAs: 'infiniteScroll',
      controller: function () {
        var vm = this;
        vm.name = 'infiniteScroll';
      },
      link: function(scope, elem, attrs) {
        var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
        $window = angular.element($window);
        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function(value) {
            return scrollDistance = parseInt(value, 10);
          });
        }
        scrollEnabled = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function(value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          });
        }
        handler = function() {

          var elementBottom, remaining, shouldScroll, windowBottom;
          windowBottom = $window.height() + $window.scrollTop();
          elementBottom = elem.offset().top + elem.height();
          remaining = elementBottom - windowBottom;
          shouldScroll = remaining <= $window.height() * scrollDistance;
          $log.debug("entered scroll, should scroll:", shouldScroll);
          if (shouldScroll && scrollEnabled) {
            $log.debug(attrs.infiniteScroll);
            if ($rootScope.$$phase) {
              return scope.$parent.$eval(attrs.infiniteScroll);
            } else {
              return scope.$parent.$apply(attrs.infiniteScroll);
            }
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };
        $window.on('scroll', handler);
        scope.$on('$destroy', function() {
          return $window.off('scroll', handler);
        });
        return $timeout((function() {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          } else {
            return handler();
          }
        }), 0);
      }
    };
  }
}());
